import ApiBase from 'Services/Api/ApiBase';

class MissingCovidTestEntries extends ApiBase {
    route = '/admin/covid/missing-covid-test-entries';
};

export default new MissingCovidTestEntries();